import Vue from 'vue'
import App from './App.vue'
import router from './router'
import $http from './util/axios.js'
import $tConfirm from './util/confirm'
import Cookies from 'js-cookie';
import $ui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import $tools from './util/tools'
import VueClipboard from 'vue-clipboard2'


Vue.use($ui);
Vue.use(VueClipboard);
Vue.prototype.$cookies = Cookies;
Vue.config.productionTip = false

var $vue = new Vue({
  router, $http, $ui, $tConfirm, $tools,
  render: h => h(App)
}).$mount('#app')
